
<style scoped>
table {
  width: 100%;
  table-layout: fixed;
}

.dist-panel {
  background: white;
  width: 650px;
  box-shadow: 0 0 2px darkgrey;
  -webkit-box-shadow:0 0 2px darkgrey;
  -moz-box-shadow:0 0 2px darkgrey;
  margin: auto;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 30px;
}

tr {
  height: 35px;
}

td:nth-child(1) {
  width: 140px;
}

td:nth-child(2) {
  color: black;
}
</style>

<template>
  <div>
    <div class="dist-panel">
      <h2 style="text-align:center;margin:20px;color:black">新点移动研发过程管理应用发布清单</h2>
      
      <Alert type="warning" show-icon>
        注意
        <template slot="desc">
            企业级分发的App，禁止将ipa包、下载链接或二维码发布到公开的互联网环境，如：门户网站、第三方蒲公英等平台。
        </template>
      </Alert>
      
      <table style="border-collapse:collapse;">
        <tr>
          <td>项目名称</td>
          <td>{{prj.projectname}}</td>
        </tr>
        <tr>
          <td>应用名称</td>
          <td>{{detail.cfbundledisplayname == null?app.appname:detail.cfbundledisplayname}}</td>
        </tr>
        <tr>
          <td>平台</td>
          <td>{{app.platform}}</td>
        </tr>
        <tr>
          <td>创建日期</td>
          <td>{{detail.createtime}}</td>
        </tr>
        <tr>
          <td>项目经理</td>
          <td>{{prj.pmname}}</td>
        </tr>

        <tr>
          <td>发布类型</td>
          <td>{{detail.disttype==1?"正式版":"测试版"}}</td>
        </tr>
        <tr>
          <td>应用包名</td>
          <td>{{detail.cfbundleidentifier == null?app.appid:detail.cfbundleidentifier}}</td>
        </tr>
        <tr>
          <td>应用版本</td>
          <td>{{detail.appversion}}</td>
        </tr>
        <tr>
          <td>开发工具(Xcode)</td>
          <td>{{detail.xcodeversion}}</td>
        </tr>
        <tr>
          <td>构建渠道</td>
          <td>{{detail.buildfrom == 1 ? "持续集成":"手动构建"}}</td>
        </tr>
        <tr>
          <td>发布渠道</td>
          <td>{{detail.distchannel== "enterprise"?"企业发布":"应用商店"}}</td>
        </tr>
        <tr>
          <td>包含来电显示</td>
          <td>{{detail.hascid == 1 ? "是":"否"}}</td>
        </tr>

        <tr>
          <td>最低系统支持</td>
          <td>{{detail.minimumosversion}}</td>
        </tr>
        <tr>
          <td>分发证书</td>
          <td>{{detail.teamname}}</td>
        </tr>
        <tr v-if="detail.distchannel == 'enterprise'">
          <td>
            描述文件过期时间
            <Icon type="ios-alert-outline" @click="alertProfileExpire" style="color:red" size="17" />
          </td>
          <td>
            <span
              v-if="detail.expiredate!=null"
            >{{detail.expiredate}}，
              <span style="border:1px solid#0fca60;background:#e3faee;padding:2px 6px;border-radius: 6px;color:#0fca60;" v-if="expire_number > 60"   >
               {{expire_number}}天后过期
              </span>
              <span style="border:1px solid#fc2912;background:#fee8e3;padding:2px 6px;border-radius: 6px;color:#fc2912;" v-if="(expire_number <= 60) && (expire_number > 0)" >
                {{expire_number}}天后过期
              </span>
              <span style="border:1px solid#808080;background:#f5f5f5;padding:2px 6px;border-radius: 6px;color:#808080;" v-if="(expire_number < 0) "   >
               已过期{{Math.abs(expire_number)}}天
              </span>
              <!-- <Alert style="max-width:100px;" v-if="(expire_number < 0) " type="error" show-icon >{{getDateInterval(stringToDate(detail.expiredate))}}天后过期</Alert> -->
            </span>
          </td>
        </tr>
        <tr>
          <td>ipa文件大小</td>
          <td>{{getFileLengthName(file.filelength)}}</td>
        </tr>
        <tr>
          <td>ipa下载</td>
          <td>
            <a
              :href="this.$axios.defaults.baseURL + '/mqms/file/downloadwithoutcode?id='+detail.filetag"
              target="_blank"
            >下载</a>
          </td>
        </tr>
        <tr>
          <td>下载地址</td>
          <td>
            <a
              :href="'/#/projdownloadpage?id='+detail.id"
              target="_blank"
            >跳转地址</a>
          </td>
        </tr>
        <tr>
          <td>包含消息推送</td>
          <td>{{detail.hasmsgpush == 1 ? "是":"否"}}</td>
        </tr>
        <tr v-if="detail.hasmsgpush == 1">
          <td>推送证书过期时间</td>
          <td>{{detail.pushcerexpiredate}}，
              <span style="border:1px solid#0fca60;background:#e3faee;padding:2px 6px;border-radius: 6px;color:#0fca60;" v-if="expire_push_number > 60"   >
               {{expire_push_number}}天后过期
              </span>
              <span style="border:1px solid#fc2912;background:#fee8e3;padding:2px 6px;border-radius: 6px;color:#fc2912;" v-if="(expire_push_number <= 60) && (expire_push_number > 0)" >
                {{expire_push_number}}天后过期
              </span>
              <span style="border:1px solid#808080;background:#f5f5f5;padding:2px 6px;border-radius: 6px;color:#808080;" v-if="(expire_push_number < 0) "   >
               已过期{{Math.abs(expire_push_number)}}天
              </span>
          </td>
        </tr>
        <tr v-if="detail.hasmsgpush == 1">
          <td>推送证书下载</td>
          <td>
            <a
              :href="this.$axios.defaults.baseURL + '/mqms/file/downloadwithoutcode?id='+detail.pushcerfiletag"
              target="_blank"
            >下载</a>
          </td>
        </tr>
        <tr>
          <td>开发者</td>
          <td>{{detail.developername}}</td>
        </tr>

        <tr>
          <td>是否自测</td>
          <td>{{detail.selftest == 1 ? "是":"否"}}</td>
        </tr>
        <tr v-show="detail.selftest == 1">
          <td>自测设备</td>
          <td>{{detail.testdevice}}</td>
        </tr>
        <tr>
          <td valign="top">更新说明</td>
          <td valign="top" style="white-space: pre-wrap">{{getReplace(detail.updateinfo)}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      detail: {},
      app: {},
      prj: {},
      file: {},
      fileurl: "",
      expire_number:0,
      expire_push_number:0,
    };
  },
  computed: {},
  methods: {
    getFileLengthName(filelength) {
      if (filelength / 1024 < 1024) {
        return (filelength / 1024).toFixed(2) + " KB";
      } else if (filelength / 1024 / 1024 < 1024) {
        return (filelength / 1024 / 1024).toFixed(2) + " MB";
      }
      return filelength;
    },
    getReplace(updateinfo) {
      var newupdateinfo = updateinfo.replace(/<br>/g,"\n")
      return newupdateinfo;
    },
    getDateInterval(endDate) {
      var date3 = endDate.getTime() - new Date().getTime();
      return Math.floor(date3 / (24 * 3600 * 1000));
    },
    stringToDate: function(dateStr, separator) {
      if (!separator) {
        separator = "-";
      }
      var dateArr = dateStr.split(separator);
      var year = parseInt(dateArr[0]);
      var month;
      //处理月份为04这样的情况
      if (dateArr[1].indexOf("0") == 0) {
        month = parseInt(dateArr[1].substring(1));
      } else {
        month = parseInt(dateArr[1]);
      }
      var day = parseInt(dateArr[2]);
      var date = new Date(year, month - 1, day);
      return date;
    },
    alertProfileExpire() {
      this.$Modal.warning({
        title: "非常重要",
        content:
          "应用能够运行的有效日期，超过该日期，软件将无法运行出现闪退，所以必须在有效日期之前给客户重新打包并更新版本。"
      });
    },
    getDetail() {
      let _this = this;
      this.$http.get({
        method: "/mqms/pkgpub/ipadetail",
        params: {
          id: this.$route.params.id
        },
        success: function(data) {
          _this.expire_number = _this.getDateInterval(_this.stringToDate(data.dist.expiredate));
          _this.expire_push_number = data.dist.pushcerexpiredate?_this.getDateInterval(_this.stringToDate(data.dist.pushcerexpiredate)):0;
          _this.detail = data.dist;
          _this.app = data.app;
          _this.prj = data.project;
          _this.file = data.file;

          _this.noticeCer(_this.expire_number, "App过期提示", "描述文件", "App");
          _this.noticeCer(_this.expire_push_number, "推送证书过期提示", "推送证书", "消息推送服务")
        },
        failure(code, msg) {}
      });
    },
    noticeCer(day, title, body, subbody){
      if (day <= 60 && day > 0) {
          this.$Notice.warning({
                    title: title,
                    desc: `当前${body}剩余${day}天，即将过期，为确保${subbody}正常运行，请即时更新${body}。`,
                })
      } else if (day < 0) {
          this.$Notice.error({
                title: title,
                desc: `当前${body}已过期${Math.abs(day)}天，请尽快更新${body}!!`,
                duration:0,
            })
      }
    },
  },
  mounted() {
    this.getDetail();
  }
};
</script>